<template>
  <div class="login-block auth-shell">
    <div class="col-10 col-sm-8 col-xl-3">
      <el-card class="auth-card">
        <div class="card-title auth-title fs-4 pb-3">Восстановление пароля</div>
        <el-form :model="form" ref="formRef" class="text-start auth-form" status-icon>
          <el-form-item
            prop="email"
            :rules="[
              { required: true, message: 'Введите email', trigger: 'blur' },
              { type: 'email', message: 'Некорректный email', trigger: ['blur', 'change'] },
            ]"
          >
            <el-input v-model="form.email" placeholder="E-mail" :prefix-icon="User" />
          </el-form-item>

          <el-form-item>
            <div class="w-100 text-end">
              <el-button class="auth-submit" :loading="isLoading" @click="submit">Отправить</el-button>
            </div>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
import { User } from '@element-plus/icons-vue'

export default {
  data() {
    return {
      form: { email: '' },
      isLoading: false
    }
  },
  methods: {
    async submit() {
      this.isLoading = true
      try {
        await this.$refs.formRef.validate()
        await this.$store.dispatch('auth/requestPasswordReset', { email: this.form.email })
      } catch {
        this.$message.error('Введите корректный email')
      }
      this.isLoading = false
    }
  },
  computed: {
    User() {
      return User
    }
  }
}
</script>

<style scoped>
.login-block {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
